import React from "react";
import NewQuoteContent from "../components/quotes/new-quote-content";

const NewQuote = () => {
  return <NewQuoteContent />;
};

export default NewQuote;
